"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoProjects = void 0;
var React = require("react");
var avatars_1 = require("components/Avatar/avatars");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var NoProjects = function () { return (React.createElement("div", { className: 'center' },
    React.createElement("div", { className: 'no-vektorio-projects' },
        React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9') }),
        React.createElement("strong", null, (0, translation_1.getLocalization)("vektorio/projects/emptyList/title")),
        React.createElement("span", null, (0, translation_1.getLocalization)("vektorio/projects/emptyList/message"))))); };
exports.NoProjects = NoProjects;
